import { eNetworkName } from 'app/services/contract/contract.config';
import { networkSettings } from 'app/services/web3/web3.config';
import { Magic } from 'magic-sdk';

export const environment = {
    production: false,
    apiBaseUrl: "https://api.kryptomon.co/",
    apiBaseUrlV22: "https://api-v2.kryptomon.co/",// "https://clownfish-app-pc887.ondigitalocean.app/",
    apiBaseUrlV22BNB: "https://api-bnb.kryptomon.co/",// "https://api-v22.kryptomon.co/",
    allowedNetwork: [eNetworkName.polygon, eNetworkName.bsc],
    apiImages: "https://kryptomon-images.ams3.digitaloceanspaces.com/",
    nftServer: "https://walrus-app-6e67h.ondigitalocean.app/",
    apiPlayfab: "https://7355A.playfabapi.com/",
    coingecko: "https://api.coingecko.com/",
    subgraph: "https://subgraph.satsuma-prod.com/df1ed19bfeaa/ce3072e1db186872ba49bc535808549807ea43d13eea8b9bd2d60fbc7aa30bd6/"

};

export const apiEndPointByNetwork = {
    BinanceSmartProd: "https://api-v2.kryptomon.co",
    Rinkeby: "https://api-staging-n7ni4.ondigitalocean.app"
}

// export const magicLink = new Magic('pk_live_CA8F776F511241BA', {
//     network: environment.BSCOptions,
// });

export const magicLink = (chain: eNetworkName) => {
    return new Magic('pk_live_CA8F776F511241BA', {
        network: {
            rpcUrl: networkSettings[chain].rpcUrls[0],
            chainId: parseInt(networkSettings[chain].chainId, 16)//56, // Smart Chain chain id
        },
    });
}

export const stripeKey = "pk_test_51NxQurEMaPKSI835RcaIAtzd41rbbvmjJLkGy7LQ3C876aGCJXLhQJvY8hr6CH4rIzm5Qhw8ZKokwvsZcAzHyOx100wkkHA4wP"
